import { Button, ButtonProps, styled } from '@mui/material';

import { removeTheseProps } from '@/utils';

export type AccessLoginButtonProps = ButtonProps & {
  isActive?: boolean;
};

export const AccessLoginButton = styled(Button, {
  shouldForwardProp: removeTheseProps<AccessLoginButtonProps>('isActive'),
})<AccessLoginButtonProps>(({ isActive }) => ({
  color: 'white',
  border: isActive ? '1px solid lightgray' : 'none',
  background: isActive ? 'none' : '#D82C0D',
  '&:hover': {
    background: '#D82C0D',
  },
}));

export const AccessRegisterButton = styled(Button, {
  shouldForwardProp: removeTheseProps<AccessLoginButtonProps>('isActive'),
})<AccessLoginButtonProps>(({ isActive }) => ({
  color: isActive ? 'lightgray' : '#D82C0D',
  border: isActive ? '1px solid lightgray' : '1px solid #D82C0D',
  '&:hover': {
    background: 'white',
    border: '1px solid #D82C0D',
  },
}));
